<template>
	<page @click="() => batchSetData = ''">
		<module :title="id ? '编辑商品' : '发布商品'" :sub-title="compClassifyName">
			<c-form ref="form">
				<c-form title="基础信息">
					<c-form-item type="input" label="商品标题" name="product_name" required></c-form-item>
					<c-form-item type="input" label="商品卖点" name="product_subtitle"></c-form-item>
					<c-form-item type="input" label="商品货号" name="product_itemnumber"></c-form-item>
          <c-form-item type="select" label="商品品牌" name="product_brand_id" :options="productBrandOptions"></c-form-item>
          <c-form-item v-show="attrConfig.length" label="商品属性" name="product_attr_list">
						<div class="box params">
							<c-form ref="attrForm" item-width="50%" inline>
								<c-form-item v-for="(item, i) in attrConfig" :key='i' :type="item.parameter_type" :label="item.parameter_name" :name="item.id" :options="item.parameter_values" :required="item.required_flag == 2"></c-form-item>
							</c-form>
						</div>
					</c-form-item>
					<c-form-item v-show="paramConfig.length" label="商品参数" name="product_paramter_list">
						<div class="box params">
							<c-form ref="paramForm" item-width="50%" inline>
								<c-form-item v-for="(item, i) in paramConfig" :key='i' :type="item.parameter_type" :label="item.parameter_name" :name="item.id" :options="item.parameter_values" :required="item.required_flag == 2"></c-form-item>
							</c-form>
						</div>
					</c-form-item>
					<c-form-item v-model="imageScale" type="radio" label="商品主图" name="product_img_type" :options="imageScaleOptions" required></c-form-item>
					<c-form-item type="image" name="product_img_list" gallery limit="5" word="主图大小不能超过3MB，3:4的比例（建议尺寸750*1000），1:1的比例（建议尺寸800*800）" :inline-word="false"></c-form-item>
					<c-form-item v-show="imageScale == 1" type="image" label="1:1主图" gallery file-word="请上传一张1:1主图<br>1:1主图将显示在商品列表、收藏夹及历史足迹等页面" name="product_square_img" required></c-form-item>
					<c-form-item type="video" label="商品视频" name="product_video_url" gallery file-word="视频格式：MP4<br>视频支持1:1，16:9，最长不超过60秒，突出1-2个核心卖点；文件大小不超过30M。"></c-form-item>
					<c-form-item label="商品描述">
						<div class="box detail flex">
							<dl class="detail-preview">
								<dt>页面预览</dt>
								<dd>
									<img v-for="(item, i) in detailImageList" :key="i" :src="item">
								</dd>
							</dl>
							<div class="detail-edit flex-grow">
								<p class="tips">仅支持上传图片，最多可上传50张，已上传<b>{{detailImageList.length}}</b>/50张，拖拽可调整顺序</p>
								<c-media v-model="detailImageList" type="image" gallery :limit="50"></c-media>
							</div>
						</div>
					</c-form-item>
					<c-form-item type="image" label="产品信息" name="product_size_img" gallery file-word="建议：图片宽度750，高度自定义。<br>背景干净整洁，浅色背景，文字信息需要在手机端能够看清楚。"></c-form-item>
				</c-form>
				
				<c-form title="规格与库存">
					<c-form-item label="SKU配置" required :inline-word="false">
						<div class="spec-list">
							<div v-for="(spec, i) in specList" :key="i" class="box spec">
								<div class="flex-center-cross">
									<span class="spec-name">{{spec.name}}</span>
									<c-checkbox v-if="spec.image" :checked="true" :disabled="true" @change="specImageHandle($event, spec)">配图</c-checkbox>
								</div>
								<div class="spec-item-list flex-wrap">
									<div v-for="(item, j) in spec.itemList" :key="j" class="spec-item flex-center-cross" :class="{'z-dis': !item.new}">
										<div v-show="spec.image" class="spec-item-img flex-center" @click="setSpecItemImage(item)">
											<i v-show="!specData[item.id].image" class="tf tf-image"></i>
											<img v-show="specData[item.id].image" :src="specData[item.id].image" alt="">
										</div>
										<input v-model="specData[item.id].value" class="spec-item-value flex-grow" type="text" :disabled="!item.new" @change="specValueVerify(item.id, spec.itemList)">
										<a v-if="item.new" v-show="spec.itemList.length > 1" class="spec-item-remove tf tf-clear" @click="removeItem(spec, j)"></a>
									</div>
								</div>
								<c-button background="#4A528D" icon="add" @click="addSpecItem(spec)">添加规格值</c-button>
								<a v-if="spec.new" v-show="specList.length > 1" class="spec-remove" @click="removeSpec(i)"><i class="tf tf-trash"></i></a>
							</div>
						</div>
					</c-form-item>
					<c-form-item label="价格及库存" required>
						<div class="sku-detail">
							<div v-show="batchSetData" class="batch-set" :style="{'left': batchSetData.left}" @click.stop>
								<p>批量填写{{batchSetData.name}}</p>
								<div class="flex">
									<input v-model="batchSetData.value" type="text">
									<c-button color="sys" height="30" @click="batchSetSku('set')">确定</c-button>
								</div>
							</div>
							
							<table>
								<thead>
									<tr>
										<th v-for="(spec, i) in specList" :key="i">{{spec.name}}</th>
										<th><b>*</b>销售价(元)<a @click.stop="batchSetSku('price', '销售价', $event)"><i class="tf tf-edit"></i></a></th>
<!--										<th><b>*</b>库存(件)<a @click.stop="batchSetSku('stock', '库存', $event)"><i class="tf tf-edit"></i></a></th>-->
										<th>划线价<a @click.stop="batchSetSku('oldPrice', '划线价', $event)"><i class="tf tf-edit"></i></a></th>
										<th>预览图</th>
										<th>重量(kg)<a @click.stop="batchSetSku('weight', '重量', $event)"><i class="tf tf-edit"></i></a></th>
										<th style="width:160px;"><b>*</b>SKU编码</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="skuList.length == 0">
										<td :colspan="specList.length + 6">暂无规格信息</td>
									</tr>
									<template v-else>
										<tr v-for="(row, i) in skuList" :key="i">
											<template v-for="(col, j) in row">
												<td v-if="rowspan(i, j)" :rowspan="rowspan(i, j)">{{specData[col].value}}</td>
											</template>
											<td>
												<c-input v-model="skuData[row.join(',')].price" type="number" decimal="2" height="30"></c-input>
											</td>
<!--											<td>-->
<!--												<c-input v-model="skuData[row.join(',')].stock" type="number" height="30" :disabled="!skuData[row.join(',')].new"></c-input>-->
<!--											</td>-->
											<td>
												<c-input v-model="skuData[row.join(',')].oldPrice" type="number" decimal="2" height="30"></c-input>
											</td>
											<td>
												<div class="sku-image flex-center-cross">
													<div class="image flex-center" @click="previewSkuImage(skuData[row.join(',')].image)">
														<div v-show="!skuData[row.join(',')].image" class="plus" @click.stop="setSkuImage(row.join(','))">
															<i class="tf tf-plus"></i>
														</div>
														<img v-show="skuData[row.join(',')].image" :src="skuData[row.join(',')].image">
													</div>
													<a v-show="skuData[row.join(',')].image" @click="setSkuImage(row.join(','))">替换</a>
													<a v-show="skuData[row.join(',')].image" class="delete" @click.stop="setSkuImage(row.join(','), true)">删除</a>
												</div>
											</td>
											<td>
												<c-input v-model="skuData[row.join(',')].weight" type="number" decimal="2" height="30"></c-input>
											</td>
											<td>
												<c-input v-model="skuData[row.join(',')].code" height="30"></c-input>
											</td>
										</tr>
									</template>
								</tbody>
							</table>
<!--							<div class="total">总库存：{{totalStock}}件</div>-->
						</div>
					</c-form-item>
				</c-form>
				
				<c-form title="其他设置">
					<c-form-item v-if="productState == 0" v-model="salesDate" type="radio" label="上架设置" name="product_first_sell_type" :options="salesDateOptions" required></c-form-item>
					<c-form-item v-if="productState == 0" v-show="salesDate == 3" type="datetime" label="上架时间" name="product_first_sell_date" required></c-form-item>
					<c-form-item type="select" label="运费模板" name="freight_template_id" :options="freightTmplOptions" required>
						<span slot="word">如果没有运费模板，点击<a class="s-link" @click="navigateTo('/freight_template')">这里创建</a></span>
					</c-form-item>
          <c-form-item type="file" label="上传附件" name="attachment_file_url" file-word="支持xls、doc、txt、rar、zip、pdf等格式"></c-form-item>
        </c-form>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(productState == 0 ? 2 : 3)">提交发布</c-button>
				<c-button v-if="productState == 0" size="m" hollow @click="submit(1)">暂存草稿</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'product_edit',
		
		props: {
			classify: String,
			classifyName: String,
			id: String
		},
		
		data() {
			return {
				productState : 0,
				productClassify: '',
				productClassifyName: [],
				
				paramConfig: [],
				attrConfig: [],
				paramValue: {},
				attrValue: {},
				
				detailImageList: [],
				
				imageScaleOptions: [{
					name: '1:1',
					value: 2
				}, {
					name: '3:4',
					value: 1
				}],
				imageScale: 2,
				
				salesDateOptions: [{
					name: '手动上架',
					value: 1
				}, {
					name: '立即上架',
					value: 2
				}, {
					name: '定时上架',
					value: 3
				}],
				salesDate: 1,
				
				freightTmplOptions: [],//运费模板数据集合
        productBrandOptions: [],//商品品牌数据集合
        specIndex: 0,
				specList: [],
				specData: {},
				skuData: {},
				skuPrivateImage: false,
				
				batchSetData: ''
			}
		},
		
		computed: {
			compClassifyName() {
				return `（类目：${this.id ? this.productClassifyName.join(' > ') : this.classifyName.split(',').join(' > ')}）`;
			},
			
			skuList() {
				var that = this, skuList = [];
				!function poll(index, tree, isNew) {
					let list = that.specList[index];
					if (!list) {
						if (tree) {
							if (!that.skuData[tree]) {
								// var specImg = tree.split(',').find(item => that.specData[item].image);
								that.$set(that.skuData, tree, {
									id: `sku${that.specIndex++}`,
									price: '',
									// stock: '',
									oldPrice: '',
									image: '',  // specImg ? that.specData[specImg].image : '',
									weight: '',
									code: '',
									new: isNew
								});
							}
							skuList.push(tree.split(','));
						}
						return;
					}
					list.itemList.forEach(item => {
						let t = tree ? tree.split(',') : [];
						t.push(item.id);
						poll(index+1, t.join(','), isNew ? isNew : item.new);
					});
				}(0);
				
				return skuList;
			},
			
			rowspan() {
				return (row, col) => {
					var count = 1;
					for (let i = col+1; i < this.specList.length; i++) {
						count *= this.specList[i].itemList.length;
					}
					
					return row % count ? 0 : count;
				}
			},
			
			totalStock() {
				var total = 0;
				this.skuList.forEach(row => {
					total += parseInt(this.skuData[row.join(',')].stock) || 0;
				});
				return total;
			}
		},
		
		watch: {
			id() {
				this.getProductDetail();
			},
			
			classify() {
				this.getParamList();
				this.getAttrList();
			},
			
			productClassify() {
				this.getParamList();
				this.getAttrList();
			}
		},
		
		mounted() {
			if (this.classify) {
          this.getParamList();
          this.getAttrList();
          this.getSpecList();
          this.getProductBrand();
          this.getFreightTmpl();
      } else {
				  this.getProductDetail();
			}
			this.$bus.$on('productEdit.updateFreightTmpl', () => {
				this.getFreightTmpl();
			})
		},
		
		methods: {
			getParamList() {
				this.request({
					url: '/product_param/common_list',
					data: {
						type:1,
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						if (data) {
							this.paramConfig = Array.from(data, item => {
								item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
								item.parameter_values = Array.from(item.parameter_values.split(','), item => {
									return {
										name: item,
										value: item
									}
								});
								return item;
							});
							
							this.$nextTick(() => {
								this.$refs.paramForm.set(this.paramValue);
							});
						}
					}
				});
			},
			getAttrList() {
				this.request({
					url: '/product_param/common_list',
					data: {
						type:2,
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						if (data) {
							this.attrConfig = Array.from(data, item => {
								item.parameter_type = item.parameter_type == 'text' ? 'input' : item.parameter_type;
								item.parameter_values = Array.from(item.parameter_values.split(','), item => {
									return {
										name: item,
										value: item
									}
								});
								return item;
							});

							this.$nextTick(() => {
								this.$refs.attrForm.set(this.attrValue);
							});
						}
					}
				});
			},
			getSpecList() {
				this.request({
					url: '/product_type/common_specs',
					data: {
						product_type_id: this.classify || this.productClassify
					},
					success: data => {
						this.skuPrivateImage = data.is_support_sku_img == 1;
						this.initSpec(data.spec_list, true);
					}
				});
			},
			getProductDetail() {
				this.request({
					url: '/product/detail',
					data: {
						product_id: this.id
					},
					loading: true,
					success: data => {
						this.productState = data.base_info.state;
						this.productClassify = data.base_info.product_type_id;
						this.productClassifyName = data.base_info.product_type_full_name.split(' > ');
            this.getProductBrand(data.base_info.product_brand_id);
            this.getFreightTmpl(data.base_info.freight_template_id);
            data.product_paramter_list.forEach(item => {
							this.paramValue[item.parameter_id] = item.parameter_value;
						});
						data.product_attr_list.forEach(item => {
							this.attrValue[item.parameter_id] = item.parameter_value;
						});
						
						let video = data.product_img_list.find(item => item.type == 2);
						this.$refs.form.set(Object.assign(data.base_info, {
							product_square_img: data.base_info.product_img_type == 1 ? data.base_info.product_img_url : '',
							product_img_list: Array.from(data.product_img_list.filter(item => item.type == 1), item => item.image_url),
							product_video_url: video ? video.image_url : ''
						}));
						
						if (data.base_info.product_content) {
							this.detailImageList = data.base_info.product_content.split(',');
						}
						
						this.skuPrivateImage = data.base_info.is_support_sku_img == 1;
						this.initSpec(data.product_spec_list);
						
						var that = this;
						!function poll(list, tree) {
							list.forEach(item => {
								let specKey = tree.concat([item.group_id]);
								if (item.children) {
									poll(item.children, specKey);
								} else {
									that.$set(that.skuData, specKey.join(','), {
										id: item.product_sku,
										price: item.product_price,
										// stock: item.product_sku_stock,
										oldPrice: item.product_price_tag || '',
										image: item.product_img_url,
										weight: item.product_weight || '',
										code: item.product_sku_code || ''
									});
								}
							});
						}(data.product_sku_list, []);
          }
				});
			},
      /*******加载商品品牌列表****/
      getProductBrand(id) {
        this.request({
          url: '/product_brand/options',
          data: {state:2},
          success: data => {
            this.productBrandOptions = Array.from(data, item => {
              return {
                name: item.brand_name,
                value: item.brand_id
              }
            });
            if (id) {
              this.$nextTick(() => {
                this.$refs.form.set({
                  product_brand_id: id
                });
              });
            }
          }
        });
      },
			getFreightTmpl(id) {
				this.request({
					url: '/freight_template/options',
					success: data => {
						this.freightTmplOptions = Array.from(data, item => {
							return {
								name: item.option,
								value: item.id
							}
						});
            if (id) {
              this.$nextTick(() => {
                this.$refs.form.set({
                  freight_template_id: id
                });
              });
            }
					}
				});
			},
			initSpec(data, apply) {
				this.specList = Array.from(data, spec => {
					return {
						name: spec.group_name,
						image: spec.group_img_flag == 2,
						itemList: Array.from(spec.children, item => {
							let id = apply ? `spec${this.specIndex++}` : item.group_id
							this.$set(this.specData, id, {
								value: item.group_value,
								image: item.group_img
							});
							
							return {
								new: apply,
								id
							}
						})
					}
				});
			},
			
			addSpec() {
				if (this.specList.length == 3) {
					this.$message({
						text: '最多只能添加三个规格项'
					});
					return;
				}
				var item = {
					new: true,
					name: '',
					image: false,
					itemList: []
				};
				this.specList.push(item);
				this.addSpecItem(item);
			},
			
			removeSpec(index) {
				this.specList.splice(index, 1);
			},
			
			specImageHandle(state, spec) {
				if (state) {
					this.specList.forEach(item => {
						if (item != spec) item.image = false;
					});
				}
				spec.image = state;
			},
			
			specValueVerify(id, list) {
				if (list.find(item => {
					return item.id != id && this.specData[item.id].value == this.specData[id].value;
				})) {
					this.$message({
						text: '规格值不能重复，请重新输入'
					});
					this.specData[id].value = '';
				}
			},
			
			addSpecItem(spec) {
				var id = `spec${this.specIndex++}`;
				
				this.$set(this.specData, id, {
					value: '',
					image: ''
				});
				
				spec.itemList.push({
					new: true,
					id
				});
			},
			
			setSpecItemImage(spec) {
				this.selectMedia({
					resolve: data => {
						this.specData[spec.id].image = data;
						// this.skuList.forEach(specKey => {
						// 	if (specKey.includes(spec.id.toString())) {
						// 		this.skuData[specKey].image = data;
						// 	}
						// });
					}
				});
			},
			
			removeItem(spec, index) {
				spec.itemList.splice(index, 1);
			},
			
			batchSetSku(type, name, e) {
				if (type == 'set') {
					this.skuList.forEach(specKey => {
						if (this.batchSetData.type != 'stock' || this.skuData[specKey].new) {
							this.skuData[specKey][this.batchSetData.type] = this.batchSetData.value;
						}
					});
					this.batchSetData = '';
				} else {
					this.batchSetData = {
						type,
						name,
						value: '',
						left: e.layerX + 'px'
					};
				}
			},
			
			setSkuImage(specKey, clear) {
				new Promise(resolve => {
					if (clear) {
						resolve('');
						return;
					}
					
					this.selectMedia({
						resolve: data => {
							resolve(data);
						}
					});
				}).then(data => {
					if (!this.skuPrivateImage) {
						let specId = specKey.split(',')[0];
						for (let key in this.skuData) {
							if (key.split(',')[0] == specId) {
								this.skuData[key].image = data;
							}
						}
					} else {
						this.skuData[specKey].image = data;
					}
				});
			},
			
			previewSkuImage(src) {
				src && this.$preview({
					src
				});
			},
			
			submit(type) {
				this.$refs.form.submit({
					url: this.id ? '/product/edit' : '/product/add',
					
					rule: {
						product_name: '请填写商品标题',
						product_attr_list: [{
							type: 'function',
							fun: value => {
								let attrData = this.$refs.attrForm.serialize();
								return !this.attrConfig.find(item => {
									return item.required_flag == 2 && !attrData[item.id];
								});
							},
							word: '请填写带星号的商品属性'
						}],
						product_paramter_list: [{
							type: 'function',
							fun: value => {
								let paramData = this.$refs.paramForm.serialize();
								return !this.paramConfig.find(item => {
									return item.required_flag == 2 && !paramData[item.id];
								});
							},
							word: '请填写带星号的商品参数'
						}],
						product_img_list: [{
							type: 'function',
							fun: value => {
								return value.length;
							},
							word: '请至少选择一张商品主图'
						}],
						product_square_img: [{
							type: 'empty',
							skip: () => {
								return this.imageScale == 2;
							},
							word: '请选择商品1:1主图'
						}],
						spec: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									if (!this.specList[i].itemList.length) {
										state = false;
										break;
									}
								}
								return state;
							},
							word: '请添加SKU配置规格值'
						}],
						spec_image: [{
							type: 'function',
							fun: () => {
								var state = true,
									spec = this.specList.find(item => item.image);
									
								if (spec) {
									for (let i in spec.itemList) {
										if (!this.specData[spec.itemList[i].id].image) {
											state = false;
											break;
										}
									}
								}
								return state;
							},
							word: '请选择规格配图'
						}],
						spec_value: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.specList) {
									for (let j in this.specList[i].itemList) {
										if (!this.specData[this.specList[i].itemList[j].id].value) {
											state = false;
											break;
										}
									}
								}
								return state;
							},
							word: '请完善规格值'
						}],
						sku_config: [{
							type: 'function',
							fun: () => {
								var state = true;
								for (let i in this.skuList) {
									let sku = this.skuData[this.skuList[i].join(',')];
									if (!sku.price || !sku.code ) {
										state = false;
										break;
									}
								}
								return state;
							},
							word: '请完善SKU价格、及SKU编码信息'
						}],
						product_first_sell_date: [{
							type: 'empty',
							skip: () => {
								return this.salesDate != 3;
							},
							word: '请选择上架时间'
						}],
						freight_template_id: '请选择运费模板'
					},
					
					dataFormatter: data => {
						let specList = [];
						this.specList.forEach((spec, i) => {
							spec.itemList.forEach((item, j) => {
								specList.push({
									group_id: item.id,
									group_name: spec.name,
									group_value: this.specData[item.id].value,
									group_img_flag: spec.image ? 2 : 1,
									group_img: this.specData[item.id].image,
									group_level: i+1,
									sort_id: j+1
								});
							});
						});
						
						let skuList = [];
						this.skuList.forEach(specKey => {
							let data = this.skuData[specKey.join(',')];
							skuList.push({
								product_sku: data.id + '',
								product_sku_spec_ids: specKey,
								product_sku_spec: Array.from(specKey, item => this.specData[item].value + '').join(' '),
								product_price: data.price + '',
								product_price_tag: data.oldPrice + '',
								// product_sku_stock: data.stock + '',
								product_img_url: data.image,
								product_weight: data.weight + '',
								product_sku_code: data.code + ''
							});
						});
						
						data.product_id = this.id || 0;
						data.product_img_url = this.imageScale == 1 ? data.product_square_img : data.product_img_list[0];
						data.product_type_id = this.$route.query.classify || this.productClassify;
						data.product_content = this.detailImageList.join(',');
						data.is_support_sku_img = this.skuPrivateImage ? 1 : 0;
						
						let paramData = this.$refs.paramForm.serialize();
						let attrData = this.$refs.attrForm.serialize();
							
						let formData = {
							operate_type: type,
							base_info: data,
							product_paramter_list: Array.from(this.paramConfig, item => {
								return {
									parameter_id: item.id,
									parameter_value: typeof paramData[item.id] == 'string' ? paramData[item.id] : paramData[item.id].join(',')
								}
							}),
							product_attr_list: Array.from(this.attrConfig, item => {
								return {
									parameter_id: item.id,
									parameter_value: typeof attrData[item.id] == 'string' ? attrData[item.id] : attrData[item.id].join(',')
								}
							}),
							product_img_list: Array.from(data.product_img_list, (item, index) => {
								return {
									image_url: item,
									type: 1,
									sort_id: index + 1
								}
							}).concat(data.product_video_url ? [{
								image_url: data.product_video_url,
								type: 2,
								sort_id: data.product_img_list.length + 1
							}] : []),
							product_spec_list: specList,
							product_sku_list: skuList
						}
						
						delete data.product_paramter_list;
						delete data.product_attr_list;
						delete data.product_square_img;
						delete data.product_video_url;
						delete data.product_img_list;
						
						return formData;
					},
					
					success: (data, param) => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('productList.update', this.id ? undefined : 1);
						this.redirectTo('/product_list');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.box {
		background: #F9F8FB;
	}
	
	.params {
		box-sizing: border-box;
		padding: 20px 20px 30px;
	}
	
	.detail {
		padding: 15px;
		
		&-preview {
			width: 370px;
			border: 1px solid #ddd;
			margin-right: 30px;
			background: #fff;
			
			dt {
				border-bottom: 1px solid #ddd;
				line-height: 40px;
				font-size: 13px;
				font-weight: bold;
				text-indent: 12px;
			}
			
			dd {
				height: 560px;
				overflow: auto;
				font-size: 0;
				
				img {
					width: 100%;
					max-height: initial;
				}
			}
		}
		
		&-edit {
			.tips {
				line-height: 40px;
				font-size: 12px;
				color: #666;
				
				b {
					font-weight: bold;
					color: #f00;
				}
			}
		}
	}
	
	.spec {
		position: relative;
		padding: 15px 17px;
		
		&:nth-child(n+2) {
			margin-top: 16px;
		}
		
		&-list {
			box-sizing: border-box;
			border: 1px dotted #ddd;
			padding: 14px;
		
			.c-button {
				margin-top: 16px;
			}
		}
		
		&-label {
			margin-right: 8px;
			line-height: 36px;
			font-size: 13px;
			white-space: nowrap;
			color: #444;
		}
		
		&-remove {
			position: absolute;
			right: 0;
			top: 0;
			width: 24px;
			line-height: 24px;
			font-size: 12px;
			text-align: center;
			color: #fff;
			background: #aaa;
			
			&:hover {
				background: #999;
			}
		}
		
		&-name {
			margin-right: 10px;
			line-height: 36px;
			font-size: 13px;
		}
		
		.c-checkbox {
			margin-top: 0;
		}
		
		&-item {
			width: 128px;
			height: 30px;
			border: 1px solid #ddd;
			padding: 0 5px;
			margin-top: 12px;
			margin-right: 12px;
			background: #fff;
			
			&.z-dis {
				background: #f5f5f5;
			}
			
			&-img {
				margin-right: 5px;
				width: 25px;
				height: 25px;
				color: #bbb;
				background: #F5F5F5;
				cursor: pointer;
			}
			
			&-value {
				font-size: 13px;
				
				&:disabled {
					cursor: not-allowed;
				}
			}
			
			&-remove {
				margin-left: 5px;
				font-size: 16px;
				color: #C70000;
			}
		}
		
		.c-button {
			margin-top: 16px;
		}
	}
	
	.sku-detail {
		position: relative;
		
		.batch-set {
			position: absolute;
			left: 0;
			top: -90px;
			padding: 0 11px 17px;
			background: #fff;
			box-shadow: 0 0 4px 0 rgba(0,0,0,.2);
			
			p {
				line-height: 43px;
				font-size: 13px;
				font-weight: bold;
			}
			
			input {
				width: 100px;
				height: 28px;
				border: 1px solid #ddd;
				padding: 0 5px;
				margin-right: 5px;
			}
		}
		
		table {
			thead {
				background: #F9F9F9;
			}
			tbody {
				background: #fff;
			}
			th, td {
				width: 100px;
				height: 40px;
				padding: 0 10px;
				line-height: 40px;
				border: 1px solid #ddd;
				color: #444;
				font-size: 12px;
				text-align: left;
			}
			
			th {
				b {
					margin-right: 5px;
					color: #f00;
				}
				
				a {
					margin-left: 5px;
				}
			}
			
			td {
				position: relative;
				
				.sku-image {
					.image {
						position: relative;
						width: 28px;
						height: 28px;
						border: 1px dotted #ccc;
						font-size: 12px;
						color: #ccc;
						cursor: pointer;
						
						&:hover {
							border-color: #999;
							color: #999;
						}
					
						div {
							position: absolute;
							left: 0;
							right: 0;
							line-height: 28px;
							text-align: center;
						}
					}
						
					a {
						margin-left: 6px;
						
						&.delete {
							color: #C70000;
							
							&:hover {
								color: #f00;
							}
						}
					}
				}
			}
		}
		
		.total {
			padding: 0 13px;
			line-height: 50px;
			font-size: 12px;
			color: #666;
			background: #F9F9F9;
		}
	}
</style>